import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { DashboardPage } from "./pages/DashboardPage";
import { AccountPage } from "./pages/AccountPage";
import { SettingsPage } from "./pages/SettingsPage";
import { ConnectedPage } from "./pages/ConnectedPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { TermsPage } from "./pages/TermsPage";
import { LoginPage } from "./pages/LoginPage";
import { SetupPage } from "./pages/SetupPage";
import { AdminPage } from "./pages/AdminPage";
import { QueuePage } from "./pages/QueuePage";
import { ReallocationPage } from "./pages/ReallocationPage";
import { ArchivePage } from "./pages/ArchivePage";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/dashboard/account/:accountId" element={<AccountPage />} />
        <Route path="/dashboard/queue" element={<QueuePage />} />
        <Route path="/dashboard/queue/:draftId" element={<QueuePage />} />
        <Route path="/dashboard/archive" element={<ArchivePage />} />
        <Route path="/dashboard/reallocation" element={<ReallocationPage />} />
        <Route path="/dashboard/reallocation/:accountId" element={<ReallocationPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/connected" element={<ConnectedPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/setup" element={<SetupPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
